<template>
  <div>
    <v-row class="mt-0">
      <v-col cols="12" class="d-flex pb-0">
        <v-col cols="4">
          <!-- create payout record -->
          <v-btn color="secondary" @click="openCreateQuoteModal()" v-if="isQuoteEdit">
            <v-icon left>mdi-newspaper-plus</v-icon>Create
          </v-btn>
          <!-- Reload button -->
          <v-btn color="secondary" @click.stop="reload()">
            <i class="fa fa-repeat fa-xs"></i>&nbsp;Reload
          </v-btn>
          <v-btn color="secondary"
          @click="downloadMasterlistRpt()">
            <v-icon small>download</v-icon> Export Excel
          </v-btn>
        </v-col>
        <v-col class="pr-0" cols="8">
          <v-select
            style="max-width:200px;float:right;"
            :items="defaultYears"
            label="Year"
            v-model="selectedFilter.year"
            outlined
            dense
            hide-details
            @change="getMasterLists()"
          ></v-select>
        </v-col>
        <!-- <v-btn @click="resetFilter" class="ml-2"  style="float: right">Reset Filters</v-btn> -->
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12">
        <v-card-title class="sub-title ma-0 pa-0">
          Summary
        </v-card-title>
      </v-col>
    </v-row> -->
    <v-layout row wrap class="mt-0" v-if="masterListSummary">
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="172px">
          <v-card-title class="title card-title one-line">Total Revenue Recognised - {{selectedFilter.year === 'All' ? '2024' : selectedFilter.year}}</v-card-title>
          <v-card-text>
            <h3>${{masterListSummary.revRecon | thousandSeprator}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="172px">
          <v-card-title class="title card-title one-line pb-0">Total Revenue for {{currentMonthYear}} (Current Month)</v-card-title>
          <v-card-text class="pb-0">
            <h3 class="pt-3 mb-1">${{masterListSummary.revReconForMonth | thousandSeprator}}</h3>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              @click="openRecognizedRevenueModal"
            >
              More Details
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="172px">
          <v-card-title class="title card-title one-line">Unallocated Revenues</v-card-title>
          <v-card-text>
            <h3 v-if="selectedFilter.year === 'All'">-</h3>
            <h3 v-else>${{masterListSummary.unRecon | thousandSeprator}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 sm6 xs12 pa-3>
        <v-card class="small-box" dark color="#363636" min-height="172px">
          <v-card-title class="title card-title one-line">Active Deal</v-card-title>
          <v-card-text>
            <h3 v-if="selectedFilter.year === 'All'">-</h3>
            <h3 v-else>{{masterListSummary.activeDealCt | thousandSeprator}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-row class="mb-3 mt-3">
      <v-col cols="12" sm="2" md="2" lg="2">
        <!-- <v-btn color="success" class="mb-2" v-if="!disableSave" @click="saveChanges()">Save Changes</v-btn>
        <v-btn color="warning" class="mb-2" v-if="!disableSave" @click="cancelEdit()">Cancel</v-btn> -->
        <v-btn
        color="warning"
        class="mt-3"
        small
        v-if="selectedLists.length > 0 && isSuperAdmin"
        @click="openActiveYearDialog">
          <v-icon small>edit</v-icon> Update Active Year
        </v-btn>
      </v-col>
      <v-col cols="12" sm="10" md="10" lg="10">
        <v-card-title class="pa-0">
          <v-spacer></v-spacer>
          <v-autocomplete
            class="autocomplete-filter"
            :items="saleUsers"
            item-value="id"
            item-text="firstName"
            label="Sale Person"
            v-model="selectedFilter.salePerson"
            clearable
            hide-details
            outlined
            dense
            @change="searchFilter()"
          ></v-autocomplete>
          <v-autocomplete
            class="autocomplete-filter"
            :items="AM"
            item-value="id"
            item-text="firstName"
            label="AM"
            v-model="selectedFilter.AM"
            clearable
            hide-details
            outlined
            dense
            @change="searchFilter()"
          ></v-autocomplete>
          <v-autocomplete
            class="autocomplete-filter"
            :items="CC"
            item-value="id"
            item-text="firstName"
            label="CC"
            v-model="selectedFilter.CC"
            clearable
            hide-details
            outlined
            dense
            @change="searchFilter()"
          ></v-autocomplete>
          <v-menu
            ref="quoteDatePicker"
            v-model="quoteDateCal"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            dense
            max-width="350px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                style="max-width:250px"
                class="autocomplete-filter"
                label="Quote Acceptance Date"
                placeholder="Quote Acceptance Date"
                v-model="selectedFilter.acceptedMonth"
                @change="searchFilter()"
                clearable
                dense
                readonly
                outlined
                hide-details
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="selectedFilter.acceptedMonth"
              type="month"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
          <v-btn @click="searchFilter" color="secondary" class="ml-2">Apply</v-btn>
        </v-card-title>
      </v-col>
    </v-row>
    <div>
      <div class="text-right">
        <v-menu
          :close-on-content-click="false"
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="secondary"
              v-bind="attrs"
              v-on="on"
              @click="openColSettingsModal"
            >
              <i class="fas fa-cog fa-lg" data-toggle="tooltip" data-placement="top" title="Settings"></i>
            </v-btn>
          </template>
        </v-menu>
      </div>
      <v-data-table
        :headers="computedHeaders"
        :search="filter"
        :items="filteredItems"
        :items-per-page="15"
        @current-items="getFiltered"
        show-select
        @toggle-select-all="selectAllLists"
        :single-select="false"
        v-model="selectedLists"
        class="master-lists-table elevation-1">
        <template v-for="(h, index) in computedHeaders" v-slot:[`header.${h.value}`]="{ header }">
          <div class="col-header-title" :key="index">
            {{h.text}}
            <v-btn x-small text v-if="showLock(`${h.value}${selectedFilter.year}`) && isQuoteEdit" @click="changeLock(`${h.value}${selectedFilter.year}`, 'lock')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon small color="secondary">mdi-lock-open-variant</v-icon>
                  </span>
                </template>
                <span>Lock</span>
              </v-tooltip>
            </v-btn>
            <v-btn x-small text v-if="showUnlock(`${h.value}${selectedFilter.year}`) && isQuoteEdit" @click="changeLock(`${h.value}${selectedFilter.year}`, 'unlock')">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon small color="secondary">mdi-lock</v-icon>
                  </span>
                </template>
                <span>Unlock</span>
              </v-tooltip>
            </v-btn>
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <td class="text-start" style="min-width:30px!important">
            <div class="w-100 pt-1" style="margin-right: 10px;" v-if="isQuoteEdit">
              <v-badge
                class="masterlist-badge"
                color="success"
                icon="mdi-clock-outline"
                x-small
                overlap
                v-if="isPendingTimeline(item.quoteData)"
              >
                <v-btn
                  class="btn-action"
                  @click="openFinanceEditDialog(item)"
                  color="warning"
                  small
                >
                  <v-icon class="cursor-pointer" title="Edit Quote" small>edit</v-icon> Edit Quote
                </v-btn>
              </v-badge>
              <v-btn
                class="btn-action"
                @click="openFinanceEditDialog(item)"
                color="warning"
                small
                v-else
              >
                <v-icon class="cursor-pointer" color="white" title="Edit Quote" small>edit</v-icon> Edit Quote
              </v-btn>
            </div>
            <div class="w-100 pt-1 pb-2" v-if="isSalesEdit">
              <v-btn
                class="btn-action"
                @click="openSalesEditDialog(item)"
                color="green"
                small
                style="color:#fff"
              >
                <v-icon class="cursor-pointer" color="white" title="Update" small>edit</v-icon> Update
              </v-btn>
            </div>
            <div class="w-100 pb-1">
              <v-btn
                class="btn-action"
                @click="refreshMasterList(item)"
                color="warning"
                small
                style="color:#fff"
              >
                <i class="fa fa-repeat fa-xs"></i>&nbsp; Refresh
              </v-btn>
            </div>
          </td>
        </template>
        <template v-slot:[`item.formattedAcceptanceDate`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <span v-if="item.formattedAcceptanceDate">{{formatDate(item.formattedAcceptanceDate)}}</span>
          </td>
        </template>
        <template v-slot:[`item.salePersonName`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <span v-if="item.salePersonName">{{item.salePersonName}}</span>
          </td>
        </template>
        <template v-slot:[`item.billingContactName`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <v-tooltip bottom max-width="300px">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <p class="custom-text-truncate">{{item.billingContactDisplay.Name || '-'}}</p>
                </div>
              </template>
              <span>{{item.billingContactDisplay.Name || '-'}}</span>
            </v-tooltip>
          </td>
        </template>
        <template v-slot:[`item.quoteNo`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <div v-if="item.quoteNo">{{item.quoteNo}}</div>
            <span v-if="item.linkedIOs">{{showLinkedIO(item.linkedIOs)}}</span>
          </td>
        </template>
        <template v-slot:[`item.quoteAmt`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.quoteAmt">${{item.quoteAmt | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.invoiceSent`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.invoiceSent">${{item.invoiceSent | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.invoiceCreated`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.invoiceCreated">${{item.invoiceCreated | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.invoicePending`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.invoicePending">${{item.invoicePending | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.verticals`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <div v-if="item.vertical">
              {{displayVerticals(item.vertical)}}
            </div>
          </td>
        </template>
        <template v-slot:[`item.campaigns`]="{ item }">
          <td class="text-start" style="min-width:200px!important">
            <div v-if="item.campaignDisplays">
              <!-- {{displayCampaigns(item.campaigns)}} -->
              <div v-for="(campaign, index) in item.campaignDisplays" :key="index">
                <v-chip
                class="campaign-name-chip"
                color="primary"
                small
                text-color="secondary">
                  {{campaign.name}}
                </v-chip>
              </div>
            </div>
          </td>
        </template>
        <template v-slot:[`item.indicateCost`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.indicateCost">${{item.indicateCost | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.AM`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <div v-if="item.AM">
              {{displayUsers(item.AM)}}
            </div>
          </td>
        </template>
        <template v-slot:[`item.CC`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <div v-if="item.CC">
              {{displayUsers(item.CC)}}
            </div>
          </td>
        </template>
        <template v-slot:[`item.startMonth`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            {{formatMonth(item.startMonth)}}
          </td>
        </template>
        <template v-slot:[`item.endMonth`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            {{formatMonth(item.endMonth)}}
          </td>
        </template>
        <template v-slot:[`item.totalMonth`]="{ item }">
          <td class="text-center" style="min-width:30px!important">
            <b class="custom-bold">{{item.totalMonth}}</b>
          </td>
        </template>
        <template v-slot:[`item.priorYear`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.priorYear">${{item.priorYear | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.Jan`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Jan', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Jan">${{item.Jan | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Jan')" @click="openDistributionEditModal(item, 'Jan')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Feb`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Feb', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Feb">${{item.Feb | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Feb')" @click="openDistributionEditModal(item, 'Feb')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Mar`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Mar', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Mar">${{item.Mar | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Mar')" @click="openDistributionEditModal(item, 'Mar')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Apr`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Apr', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Apr">${{item.Apr | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Apr')" @click="openDistributionEditModal(item, 'Apr')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.May`]="{ item }">
          <td :class="`text-start ${getCellStatClr('May', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.May">${{item.May | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'May')" @click="openDistributionEditModal(item, 'May')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Jun`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Jun', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Jun">${{item.Jun | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Jun')" @click="openDistributionEditModal(item, 'Jun')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Jul`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Jul', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Jul">${{item.Jul | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Jul')" @click="openDistributionEditModal(item, 'Jul')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Aug`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Aug', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Aug">${{item.Aug | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Aug')" @click="openDistributionEditModal(item, 'Aug')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Sep`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Sep', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Sep">${{item.Sep | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Sep')" @click="openDistributionEditModal(item, 'Sep')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Oct`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Oct', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Oct">${{item.Oct | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Oct')" @click="openDistributionEditModal(item, 'Oct')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Nov`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Nov', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Nov">${{item.Nov | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Nov')" @click="openDistributionEditModal(item, 'Nov')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.Dec`]="{ item }">
          <td :class="`text-start ${getCellStatClr('Dec', item)}`" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.Dec">${{item.Dec | thousandSeprator}}</b>
            <v-btn color="warning btn-edit-mth" x-small v-if="isAmtEdit && !isLockMonth(item, 'Dec')" @click="openDistributionEditModal(item, 'Dec')">
              <v-icon class="cursor-pointer" color="white" title="Update" x-small>edit</v-icon>
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.nextYear`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.nextYear">${{item.nextYear | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.revenueYetRecognise`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.revenueYetRecognise">${{item.revenueYetRecognise | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.unrecognisedRevenues`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.unrecognisedRevenues">${{item.unrecognisedRevenues | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.accruedRevenue`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.accruedRevenue">${{item.accruedRevenue | thousandSeprator}}</b>
          </td>
        </template>
        <template v-slot:[`item.deferredRevenue`]="{ item }">
          <td class="text-start" style="min-width:100px!important">
            <b class="custom-bold" v-if="item.deferredRevenue">${{item.deferredRevenue | thousandSeprator}}</b>
          </td>
        </template>
        <!-- Start Footer Area -->
        <template slot="body.append">
          <tr>
            <th></th>
            <th class="text-center" v-for="(item, index) in computedHeaders" :key="index">
              <v-chip
                class="summary-chip"
                small
                color="primary"
                text-color="white"
                v-if="totalValues[item.value]"
              >
              <v-icon small left class="mr-0">mdi-currency-usd</v-icon> {{totalValues[item.value] | thousandSeprator}}
              </v-chip>
            </th>
          </tr>
        </template>
      </v-data-table>
    </div>
    <create-quote-modal
      v-model="createQuoteDialog"
      :value="createQuoteDialog"
      :editData="editData"
      :saleUsers="saleUsers"
      @created="reload"
    />
    <sales-edit-modal
      v-model="salesEditDialog"
      :value="salesEditDialog"
      :editData="editData"
      @created="reload"
    />
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <table-cols-show-hide-modal
      v-model="colSettingsDialog"
      title="Masterlist"
      :items="tableColsItems"
      @updated="updateTableCols"
    />
    <recognized-revenue-modal
      v-model="revRecognizedDialog"
      :value="revRecognizedDialog"
      :monthYearValues="masterListSummary.revsForMonthYear"
      :selectedFilter="selectedFilter"
      :masterlists="masterLists"
      :AM="AM"
      :CC="CC"
      v-if="masterListSummary"
    />
    <active-year-modal
      v-model="activeYearDialog"
      :value="activeYearDialog"
      :items="selectedLists"
    />
    <distribution-edit-modal
      v-model="distributionEditDialog"
      :value="distributionEditDialog"
      :editItem="editDistribution"
      @updated="getMasterLists"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/utils'
import config from '@/config'
import MasterListsConfig from './config'
import userAPIs from '../../User/userAPIs';
import campaignAPIs from '../../Campaign/campaignAPIs';
import CreateQuoteModal from './CreateQuoteModal';
import SalesEditModal from './SalesEditModal';
import RecognizedRevenueModal from './RecognizedRevenueModal';
import ActiveYearModal from './ActiveYearModal';
import DistributionEditModal from './DistributionEditModal';
import TableColsShowHideModal from '@/components/scoped/custom/TableColsShowHideModal'
import Loading from 'vue-loading-overlay';
import moment from 'moment'
import uniq from 'lodash/uniq';
import reverse from 'lodash/reverse';
export default {
  name: 'MasterListsDataTable',
  components: {
    Loading,
    CreateQuoteModal,
    SalesEditModal,
    RecognizedRevenueModal,
    TableColsShowHideModal,
    ActiveYearModal,
    DistributionEditModal
  },
  props: ['refresh'],
  data() {
    return {
      headers: MasterListsConfig.tableHeaders,
      dynamicMonthLists: MasterListsConfig.dynamicMonthLists,
      saleUsers: [],
      AM: [],
      CC: [],
      campaignVerticals: [],
      filteredItems: [],
      filter: '',
      createQuoteDialog: false,
      salesEditDialog: false,
      isLoading: false,
      editData: null,
      yearEditData: null,
      colSettingsDialog: false,
      revRecognizedDialog: false,
      activeYearDialog: false,
      colStatuses: {},
      userProfile: {},
      selectedFilter: {
        year: 2026,
        salePerson: '',
        AM: '',
        acceptedMonth: ''
      },
      totalValues: MasterListsConfig.defaultTotalValues,
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      IOSearched: false,
      selectedLists: [],
      distributionEditDialog: false,
      editDistribution: {},
      masterListSummary: null
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns,
      masterLists: state => state.campaign.masterLists
    }),
    currentUserRole() {
      return Number(this.$store.state.user.role)
    },
    isSuperAdmin() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    isQuoteEdit() {
      return this.currentUserRole === config.userRoles.FINANCE ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    isSalesEdit() {
      return this.currentUserRole === config.userRoles.AD_STRATEGIST ||
        this.currentUserRole === config.userRoles.ACCOUNT_MANAGER ||
        this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
        this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    isAmtEdit() {
      return this.currentUserRole === config.userRoles.FINANCE ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW
    },
    computedHeaders() {
      let masterListCols = null
      let headers = Object.assign([], this.headers)
      if (this.selectedFilter.year) {
        let filterYear = ''
        if (this.selectedFilter.year === 'All') {
          filterYear = parseInt(this.currentYear)
        } else {
          filterYear = this.selectedFilter.year
        }
        // change upon year filter on table header
        headers = headers.map(h => {
          if (h.value === 'priorYear') {
            h.text = `Prior ${filterYear}`
          }
          if (h.value === 'nextYear') {
            h.text = `For Year ${filterYear + 1}`
          }
          let matchMonth = this.dynamicMonthLists.find(dMonth => dMonth === h.value)
          if (matchMonth) {
            h.text = `${matchMonth}-${filterYear}`
          }
          // revenue yet to recognize
          if (h.value === 'revenueYetRecognise') {
            h.text = this.getRevYetColTitle()
          }
          return h
        })
      }
      // set col statuses from user table
      if (this.userProfile.tableSettings) {
        if (this.userProfile.tableSettings.masterListCols) {
          masterListCols = Object.assign({}, this.userProfile.tableSettings.masterListCols)
        }
      }
      if (masterListCols) {
        this.colStatuses = Object.assign({}, masterListCols)
      } else {
        // default true if no col status in local storage
        headers.map(header => {
          this.colStatuses[header.value] = true
        })
      }
      return headers.filter(h => {
        if (this.colStatuses[h.value]) {
          return true
        }
        return false
      });
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    currentMonth: function() {
      return moment().format('MMM')
    },
    currentYear: function() {
      return moment().format('YYYY')
    },
    currentMonthYear: function() {
      return moment().format('MMM YYYY')
    },
    daysInMonth: function() {
      return moment().daysInMonth();
    }
  },
  async mounted() {
    await this.getUsers()
    this.saleUsers = await this.getSaleUsers()
    await this.getAllCampaigns()
    this.getMasterLists()
    await this.getUserProfile()
    if (this.$route.query.IO && !this.IOSearched) {
      this.filter = this.$route.query.IO
    }
  },
  methods: {
    async getMasterLists() {
      this.isLoading = true
      // this.selectedFilter = {
      //   year: 2023,
      //   salePerson: '',
      //   acceptedMonth: ''
      // }
      await this.$store.dispatch('campaign/getCampaignMasterLists', {
        filters: {
          year: this.selectedFilter.year
        }
      })
      // this.getMasterListSummary()
      this.searchFilter()
      this.isLoading = false
    },
    // async getMasterListSummary() {
    //   this.isLoading = true
    //   await this.$store.dispatch('campaign/getMasterListSummary', {
    //     filters: {
    //       year: this.selectedFilter.year
    //     }
    //   })
    // },
    searchFilter() {
      this.filteredItems = []
      let items = Object.assign([], this.masterLists)
      this.filteredItems = items.map(i => i)
      if (this.selectedFilter.AM) {
        // filter from multiple AMs in masterlists
        this.filteredItems = this.filteredItems.filter(i => {
          let AMs = i.AM.map(a => a.id)
          if (AMs.includes(this.selectedFilter.AM)) {
            return true
          } else {
            if (this.selectedFilter.AM === 'Empty') {
              return AMs.length === 0
            }
          }
          return false
        })
      }
      if (this.selectedFilter.CC) {
        // filter from multiple CCs in masterlists
        this.filteredItems = this.filteredItems.filter(i => {
          let CCs = i.CC.map(a => a.id)
          if (CCs.includes(this.selectedFilter.CC)) {
            return true
          } else {
            if (this.selectedFilter.CC === 'Empty') {
              return CCs.length === 0
            }
          }
          return false
        })
      }
      if (this.selectedFilter.salePerson) {
        this.filteredItems = this.filteredItems.filter(i => i.salePerson === this.selectedFilter.salePerson)
      }
      if (this.selectedFilter.acceptedMonth) {
        this.filteredItems = this.filteredItems.filter(i => i.formattedAcceptanceDate.includes(this.selectedFilter.acceptedMonth))
      }
      this.masterListSummary = this.getMasterListSummary()
    },
    async getUsers() {
      let response = null
      // Get all AM by role
      response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      if (response) {
        this.AM = response.users
        this.AM = this.AM.map(am => {
          am.name = `${am.firstName} ${am.lastName}`
          return am
        })
        this.AM.unshift({
          id: 'Empty',
          firstName: 'Empty'
        })
      }
      // Get all CO by role
      response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (response) {
        this.CC = response.users
        this.CC = this.CC.map(cc => {
          cc.name = `${cc.firstName} ${cc.lastName}`
          return cc
        })
        this.CC.unshift({
          id: 'Empty',
          firstName: 'Empty'
        })
      }
    },
    async getCampaignVerticals() {
      // Get all campaign verticals and unshift for filter
      let vResp = await campaignAPIs.getAllCampaignVerticals(false)
      this.campaignVerticals = vResp.data
    },
    async getSaleUsers() {
      let resp = await userAPIs.getAllUsersByRole(config.userRoles.COMPANY_ADMIN_LOW)
      return resp.users
    },
    async getCampaignByIONumber(ioNumbers) {
      let filter = {
        filters: {
          ioNumbers
        }
      }
      await this.$store.dispatch('campaign/getCampaigns', filter)
    },
    async getAllCampaigns() {
      // get all campaigns
      await this.$store.dispatch('campaign/getCampaigns', {})
    },
    formatCampaignVerticals(campaign) {
      let selectedCampaignVertical = []
      if (campaign.vertical) {
        this.campaignVerticals.map(item => {
          campaign.vertical.map(vertical => {
            if (item.id === vertical) {
              selectedCampaignVertical.push(item)
            }
          })
        })
      }
      return selectedCampaignVertical
    },
    getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut'
      }
      return itemName
    },
    openCreateQuoteModal() {
      this.editData = null
      this.createQuoteDialog = true
    },
    openDistributionEditModal(item, month) {
      this.distributionEditDialog = false
      let monthNo = utils.func.getMonthNo(month)
      this.editDistribution = Object.assign({}, {
        id: item.id,
        amount: item[month] || 0,
        recordedMonths: item.recordedMonths || [],
        editedMonths: item.editedMonths || [],
        recordCheck: false,
        editedMonth: `${this.selectedFilter.year}-${monthNo}`,
        editedCheck: false,
        currentMonth: `${month}${this.selectedFilter.year}`,
        monthlyRates: item.monthlyRates,
        editHistory: item.editHistory || []
      })
      this.editDistribution.editHistory = reverse(this.editDistribution.editHistory)
      if (item.recordedMonths) {
        if (Array.isArray(item.recordedMonths)) {
          if (item.recordedMonths.includes(`${month}${this.selectedFilter.year}`)) {
            this.editDistribution.recordCheck = true
          }
        }
      }
      if (item.editedMonths) {
        if (Array.isArray(item.editedMonths)) {
          if (item.editedMonths.includes(`${this.selectedFilter.year}-${monthNo}`)) {
            this.editDistribution.editedCheck = true
          }
        }
      }
      this.distributionEditDialog = true
    },
    reload() {
      // impl reload here
      this.getMasterLists()
    },
    displayVerticals(verticals) {
      return verticals.join(', ')
    },
    displayCampaigns(campaigns) {
      let displayNames = campaigns.map(c => c.name)
      return displayNames.join(', ')
    },
    displayUsers(users) {
      let displayNames = users.map(c => `${c.firstName} ${c.lastName}`)
      displayNames = uniq(displayNames)
      return displayNames.join(', ')
    },
    openFinanceEditDialog(item) {
      this.editData = Object.assign({}, item)
      this.createQuoteDialog = true
    },
    openSalesEditDialog(item) {
      this.editData = Object.assign({}, item)
      this.salesEditDialog = true
    },
    formatMonth(date) {
      if (!date) return '';
      return moment(date).format('MMM YYYY');
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    openColSettingsModal() {
      this.tableColsItems = []
      let tmpStatuses = {}
      if (Object.keys(this.colStatuses).length) {
        tmpStatuses = Object.assign({}, this.colStatuses)
      } else {
        this.headers.map(header => {
          tmpStatuses[header.value] = true
        })
      }
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(this.headers)) {
        if (value.text) {
          this.tableColsItems.push({
            title: value.text,
            key: value.value,
            value: tmpStatuses[value.value] ? tmpStatuses[value.value] : false
          })
        }
      }
      this.colSettingsDialog = true
    },
    async updateTableCols(items) {
      let columns = this.colStatuses
      items.map(item => {
        columns[item.key] = item.value
      })
      let tableSettings = {}
      if (this.userProfile.tableSettings) {
        tableSettings = this.userProfile.tableSettings
      }
      tableSettings.masterListCols = Object.assign({}, columns)
      let updateData = {
        id: this.currentUserID,
        tableSettings
      }
      await userAPIs.editUser(updateData)
      // localStorage.setItem('MasterListCols', JSON.stringify(columns))
      this.colStatuses = Object.assign({}, columns)
      this.colSettingsDialog = false
    },
    async getUserProfile() {
      let resp = await userAPIs.getUser(this.currentUserID)
      if (resp && resp.id) {
        this.userProfile = resp
      }
    },
    getFiltered(filtered) {
      // get filtered total values
      this.totalValues = Object.assign({}, MasterListsConfig.defaultTotalValues)
      if (filtered.length > 0) {
        filtered.map(f => {
          for (var key of Object.keys(MasterListsConfig.defaultTotalValues)) {
            this.totalValues[key] += f[key] && !isNaN(f[key]) ? Number(f[key]) : 0
          }
        })
        for (var key of Object.keys(MasterListsConfig.defaultTotalValues)) {
          this.totalValues[key] = this.totalValues[key].toFixed(2)
        }
      }
    },
    getRevYetColTitle() {
      if (Number(this.selectedFilter.year) === Number(this.currentYear)) {
        return `Revenue yet to recognise (as at end ${this.daysInMonth} of ${this.currentMonth})`
      } else {
        return `Revenue yet to recognise (as at end 31 of Dec)`
      }
    },
    openRecognizedRevenueModal() {
      this.revRecognizedDialog = true
    },
    async downloadMasterlistRpt() {
      this.isLoading = true
      let masterListIds = this.filteredItems.map(i => i.id)
      let data = {
        year: this.selectedFilter.year,
        masterListIds
      }
      campaignAPIs
        .downloadMasterListsReport(data)
        .then(() => {
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          console.log('error in downloading masterlists report', error);
        });
    },
    showLock(monthYear) {
      let lockedMonths = []
      let selectedYear = this.selectedFilter.year
      if (this.filteredItems.length > 0) {
        lockedMonths = this.filteredItems[0].lockedMonths
      }
      let monthLists = Object.assign([], this.dynamicMonthLists)
      monthLists = monthLists.map(m => `${m}${selectedYear}`)
      if (monthLists.includes(monthYear) && !lockedMonths.includes(monthYear)) {
        return true
      }
      return false
    },
    showUnlock(month) {
      let lockedMonths = []
      let selectedYear = this.selectedFilter.year
      let monthLists = Object.assign([], this.dynamicMonthLists)
      monthLists = monthLists.map(m => `${m}${selectedYear}`)
      if (this.filteredItems.length > 0) {
        lockedMonths = this.filteredItems[0].lockedMonths
      }
      if (monthLists.includes(month) && lockedMonths.includes(month)) {
        return true
      }
      return false
    },
    getCellStatClr(month, item) {
      let currentMthYear = `${month}${this.selectedFilter.year}`
      let isNewDistr = false
      let isEditedAmt = false
      if (item.lockedMonths) {
        // for locked months (top data table level)
        if (item.lockedMonths.includes(currentMthYear)) {
          return 'bg-grey lighten-1'
        }
      }
      if (item[month]) {
        // if allocated month in monthly lists
        isNewDistr = true
      }
      if (item.recordedMonths) {
        // check in recorded months
        if (Array.isArray(item.recordedMonths)) {
          if (item.recordedMonths.includes(currentMthYear)) {
            isNewDistr = false
          }
        }
      }
      if (item.editedMonths) {
        // check in edited months
        if (Array.isArray(item.editedMonths)) {
          let editMonths = item.editedMonths.map(e => moment(e).format('MMMYYYY'))
          if (editMonths.includes(currentMthYear)) {
            isNewDistr = false
            isEditedAmt = true
          }
        }
      }
      if (isEditedAmt) {
        return 'bg-blue'
      }
      if (isNewDistr) {
        return 'bg-yellow'
      }
      return ''
    },
    async changeLock(value, status) {
      this.isLoading = true
      // change lock according to status
      let dataObj = {
        month: value,
        year: this.selectedFilter.year,
        status
      }
      await this.$store.dispatch('campaign/changeMasterListLock', dataObj)
      this.getMasterLists()
    },
    selectAllCampaigns($event) {
      if (($event.value && $event.items.length === 0) || !$event.value) {
        this.selectedLists = [];
        return;
      }
      if (this.selectedLists.length === 0) {
        this.selectedLists = $event.items
      } else this.selectedLists = []
    },
    openActiveYearDialog() {
      this.activeYearDialog = true
    },
    isPendingTimeline(timelines) {
      if (!timelines) return false
      let isPending = false
      timelines.map(t => {
        if (t.status === 0) isPending = true
      })
      return isPending
    },
    getMasterListSummary() {
      let selectedYear = this.selectedFilter.year ? this.selectedFilter.year : moment().format('YYYY')
      let revRecon = 0
      let revReconForMonth = 0
      let unRecon = 0
      let shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      let currentMonthYear = moment().format('MMM') + '' + moment().format('YYYY')
      let matchMonths = shortMonths.map(m => `${m}${selectedYear}`)
      let revsForMonthYear = matchMonths.map(m => {
        return {
          month: m,
          amount: 0,
          unallocatedAmt: 0,
          totalRevenue: 0,
          allocatedCampaigns: 0
        }
      })
      // rev for current years summary boxes based on filtered data
      for (let item of this.filteredItems) {
        let allAmts = 0
        let createdMonth = moment(item.createdAt).format('MMMYYYY')
        if (item.monthlyRates) {
          for (let [key, value] of Object.entries(item.monthlyRates)) {
            allAmts += parseFloat(value)
            if (key === currentMonthYear) {
              // current month year (MMM-YYYY)
              revReconForMonth += parseFloat(value)
            }
            if (key.includes(selectedYear)) {
              // current year (YYYY)
              revRecon += parseFloat(value)
            }
          }
        }
        unRecon += parseFloat(item.quoteAmt - allAmts)
        let revMYIdx = revsForMonthYear.findIndex(rev => rev.month === createdMonth)
        if (revMYIdx !== -1) {
          revsForMonthYear[revMYIdx].unallocatedAmt += parseFloat(unRecon)
        }
      }
      // rev month year lists based on all data
      for (let item of this.masterLists) {
        let createdMonth = moment(item.createdAt).format('MMMYYYY')
        if (item.monthlyRates) {
          for (let [key, value] of Object.entries(item.monthlyRates)) {
            let revMYIdx = revsForMonthYear.findIndex(rev => rev.month === key)
            if (revMYIdx !== -1) {
              revsForMonthYear[revMYIdx].amount += parseFloat(value)
            }
          }
        }
        // calc total revenue
        let revMYIdx = revsForMonthYear.findIndex(rev => rev.month === createdMonth)
        if (revMYIdx !== -1) {
          revsForMonthYear[revMYIdx].totalRevenue += parseFloat(item.quoteAmt)
        }
        // calc allocated campaigns
        if (revMYIdx !== -1) {
          revsForMonthYear[revMYIdx].allocatedCampaigns += item.campaignIDs ? parseInt(item.campaignIDs.length) : 0
        }
      }
      revsForMonthYear = revsForMonthYear.map(rm => {
        rm.month = rm.month.replace(selectedYear.toString(), ' ' + selectedYear)
        rm.amount = parseFloat(parseFloat(rm.amount, 2).toFixed(2))
        rm.unallocatedAmt = parseFloat(parseFloat(rm.unallocatedAmt, 2).toFixed(2))
        rm.totalRevenue = parseFloat(parseFloat(rm.totalRevenue, 2).toFixed(2))
        return rm
      })
      let activeDealCt = this.filteredItems.filter(item => item.lineOfServices !== 'Loading Fees' && item.lineOfServices !== 'Academy').length
      return {
        revRecon: parseFloat(parseFloat(revRecon, 2).toFixed(2)),
        revReconForMonth: parseFloat(parseFloat(revReconForMonth, 2).toFixed(2)),
        unRecon: parseFloat(parseFloat(unRecon, 2).toFixed(2)),
        revsForMonthYear,
        activeDealCt
      }
    },
    async refreshMasterList(item) {
      this.isLoading = true
      await this.$store.dispatch('campaign/refreshMasterList', {
        data: [
          {
            id: item.id
          }
        ]
      })
      this.getMasterLists()
    },
    isCurrentMth(mth) {
      return this.currentMonth === mth
    },
    showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return ''
      IOs = IOs.map(i => {
        if (!i.includes('IO-')) {
          i = `IO-${i}`
        }
        return i
      })
      return IOs.join(', ')
    },
    isLockMonth(item, month) {
      if (item.lockedMonths) {
        if (item.lockedMonths.includes(`${month}${this.selectedFilter.year}`)) {
          return true
        }
      }
      return false
    }
  }
}
</script>
<style scoped>
  .autocomplete-filter {
    max-width: 200px;
    margin-right: 15px!important;
    margin-bottom: -10px!important;
  }
  .bg-grey {
    background-color: #f1f1f1;
  }
</style>
<style>
.master-lists-table {
  margin-bottom: 40px;
}
.master-lists-table table {
  /* table-layout: fixed; */
  width: 100%;
}
.master-lists-table tbody td {
  border-right: 1px solid #dddddd;
  height: 38px!important;
}

.master-lists-table .default-input {
  border:1px solid black;
}

.master-lists-table tbody td {
  min-width: 100px;
  padding: 0px!important;
  padding-left: 10px!important;
}

.master-lists-table .btn-action {
  font-size: 11px!important;
  min-width: 90px!important;
  max-width: 90px!important;
}

.master-lists-table .custom-bold {
  font-weight: 500;
}

.master-lists-table .campaign-name-chip {
  line-break: auto;
  max-width: 200px;
  white-space: normal;
  vertical-align: top;
  display: inline-block;
  height: auto!important;
  margin-right: 10px;
  margin-bottom: 5px;
}
.master-lists-table .v-data-table-header tr th:first-child,
.master-lists-table tbody tr td {
  width: 30px!important;
  min-width: 30px!important;
}
.master-lists-table .btn-edit-mth {
  max-width: 20px!important;
  min-width: 20px!important;
  padding: 0!important;
}
.masterlist-badge.v-badge--icon .v-badge__badge {
  padding: 3px 0px!important;
}
.master-lists-table .bg-black {
  border: 1px solid #fff!important;
}
.master-lists-table .bg-grey.lighten-1 {
  background: #BDBDBD;
}
</style>



// WEBPACK FOOTER //
// DataTable.vue?f881d190